import { Inject, Injectable } from "@angular/core";
import {
  OrderControllerService,
  PaymentControllerService
} from "@aparraga/ahoracrypto-api-sdk/sdk";
import { AccountControllerService } from "@aparraga/ahoracrypto-api-sdk/sdk/api/accountController.service";
import { TransactionControllerService } from "@aparraga/ahoracrypto-api-sdk/sdk/api/transactionController.service";
import { BehaviorSubject } from "rxjs";
import { Address } from "../domain/address";
import { User } from "../domain/user";
import { I18nServices } from "../i18n/i18n.service";
import { RecaptchaService } from "../recaptcha/recaptcha.service";
import { IS_BROWSER } from "../utils/injectiontokens";
import { LocalStorageService } from "../storage/local-storage.service";

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  protected userInSession: User;
  protected jwt: string;
  public userSubject$: BehaviorSubject<User> = new BehaviorSubject<User>(null);

  protected controllers = [];

  public constructor(@Inject(IS_BROWSER) protected isBrowser: boolean,
                     protected orderControllerService: OrderControllerService,
                     protected i18nService: I18nServices,
                     protected recaptchaService: RecaptchaService,
                     protected paymentControllerService: PaymentControllerService,
                     protected transactionControllerService: TransactionControllerService,
                     protected accountControllerService: AccountControllerService,
                     protected storageService: LocalStorageService) {
    if(this.isBrowser) {
      this.controllers.push(this.orderControllerService);
      this.controllers.push(this.paymentControllerService);
      this.controllers.push(this.accountControllerService);
      this.controllers.push(this.transactionControllerService);

      this.recaptchaService.token$.subscribe((token) => {
        if(token != null) {
          let tokenHeaderParameter = "X-Press-Token";
          this.controllers.forEach(controller => {
            controller.defaultHeaders = controller.defaultHeaders.set(tokenHeaderParameter, token);
          });
        }
      });

      this.jwt = this.storageService.getObject<string>("jwt");
      if(this.jwt != null) {
        this.setJwt(this.jwt);
      }
    }
  }

  public login() {
    //todo ...
    this.save();
  }

  public logout() {
    this.clearUserInSession();
  }

  public isAnonymous() {
    if(!!this.userInSession) {
      return false;
    }
    return true;
  }

  public setJwt(jwt) {
    this.jwt = jwt;
    //need to do this with every other guys:
    this.controllers.forEach(controller => {
      controller.configuration.credentials['jwt'] = jwt['token'];
    });
    this.refreshUserInSession();
    this.save();
  }

  public refreshUserInSession() {

    if(this.jwt == null) {
      this.jwt = this.storageService.getObject<string>("jwt");
      if(this.jwt != null) {
        //need to do this with every other guys:
        this.controllers.forEach(controller => {
          controller.configuration.credentials['jwt'] = this.jwt['token'];
        });
      }
    }

    let promise: Promise<User> = new Promise(async (resolve, reject) => {
      setTimeout(() => {
        if(this.jwt != null) {
          this.accountControllerService.accountControllerGetUserProfile().subscribe(
            (userProfile) => {
              if(userProfile != null) {
                let userInSession = new User();
                userInSession.id = userProfile.id;
                userInSession.email = userProfile.email;
                userInSession.phone = userProfile.phone;
                userInSession.profileLevel = userProfile.profileLevel;
                userInSession.phonePrefix = userProfile.phonePrefix;
                userInSession.emailVerified = userProfile.emailVerified;
                userInSession.phoneVerified = userProfile.phoneVerified;
                userInSession.infoVerificationStatus = userProfile.infoVerificationStatus;
                userInSession.registrationStatus = userProfile.registrationStatus;
                userInSession.address = new Address();
                userInSession.fs = userProfile.fs;
                userInSession.address.firstName = userProfile.firstName;
                userInSession.address.lastName = userProfile.lastName;
                userInSession.address.street = userProfile.street;
                userInSession.address.apartment = userProfile.apartment;
                userInSession.address.city = userProfile.city;
                userInSession.address.regionCode = userProfile.province;
                userInSession.address.postalCode = userProfile.postalCode;
                userInSession.address.countryIsoCode = userProfile.country;
                if (userProfile.language != null) {
                  userInSession.language = userProfile.language;
                } else {
                  userInSession.language = this.i18nService.getLanguageIsoCode();
                }
                this.setUserInSession(userInSession);
                resolve(userInSession);
              }
              else {
                resolve(null);
              }
            },
            (error) => {
              resolve(null);
            });
        }
        else {
          resolve(null);
        }
      });
    });

    return promise;

  }

  public setUserInSession(user: User) {
    this.userInSession = user;
    this.userSubject$.next(this.userInSession);
  }

  public getUserInSession() {
    return this.userInSession;
  }

  public clearUserInSession() {
    this.userInSession = null;
    this.jwt = null;
    this.controllers.forEach(controller => {
      delete controller.configuration.credentials['jwt'];
    });
    if(this.isBrowser) {
      this.storageService.removeItem('jwt');
    }
    this.userSubject$.next(this.userInSession);
  }

  public save() {
    if(this.isBrowser) {
      this.storageService.setObject('jwt', this.jwt);
    }
  }


}
